import React, { useState } from 'react';
import '../../../../../App.css';
import { Modal, Table } from 'antd';
import {
  useReprocessRequest,
  useReprocessFailedRequest
} from '../hooks/usePayment';
import { Layout } from '../../layout';
import { useLocation, useNavigate } from 'react-router-dom';

function dragAndDrop() {
  const dragDropArea = document.getElementById('uploadArea');
}

const RejectedPayments = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [dataSource, setDataSource] = useState<any[]>([]);

  const [confirmationModal, setConfirmationModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [accountToMakePaymentFrom, setAccountToMakePaymentFrom] = useState('');

  const { data: dataM, error, mutate, isLoading } = useReprocessRequest();

    const { data: dataF, mutate: mutateF, isLoading: isLoadingF } = useReprocessFailedRequest();


  const navigate = useNavigate();

  let totalAmount = 0;
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    //console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const location = useLocation();
  const { data } = location?.state;
  

  const paymentInstruction = data?.content?.data?.paymentInstructions


    console.log(data);




  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',

    });

  }, []);

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Expense Type',
      dataIndex: 'expenseType',
      key: 'expenseType',
    },
    {
      title: 'VoxePay Payment Reference ',
      dataIndex: 'gpr',
      key: 'gpr',
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      title: 'Processing Fee',
      dataIndex: 'processingFee',
      key: 'processingFee',
    },
    {
      title: 'Funding Account',
      dataIndex: 'fundingAccount',
      key: 'fundingAccount',
    },
    {
      title: 'Beneficiary Account',
      dataIndex: 'beneficiaryAccount',
      key: 'beneficiaryAccount',
    },
    {
      title: 'Beneficiary Name',
      dataIndex: 'beneficiaryName',
      key: 'beneficiaryName',
    },
  ];

  const dataSourceD: any[] = [];
  
    const processingFee = 100 * Number(paymentInstruction.length)
  let totalPayableSum =0


  for (let i = 0; i < paymentInstruction.length; i++) {

totalPayableSum = totalPayableSum + paymentInstruction[i]?.amount


    

          const datad = {
        key: i.toString(),
        id: i +1,
        expenseType: data?.content?.data?.expenseType,
        gpr: data?.content?.data?.batchId ,
        amount: paymentInstruction[i]?.amount,
        processingFee: 100,
        fundingAccount: paymentInstruction[i].sourceAccount,
        beneficiaryAccount: paymentInstruction[i].destinationAccount,
        beneficiaryName: paymentInstruction[i].destAccountName,
        
         
      
      };
      dataSourceD.push(datad);

  }


  const submit = () => {

    console.log(data.status);


    if (data.status === 'FAILED') {

           mutateF(
       data?.id,
        {
          onSuccess: (res: any) => {
            setSuccessModal(true);
          },
        }
      );
      
    } else {
           mutate(
       data?.id,
        {
          onSuccess: (res: any) => {
            setSuccessModal(true);
          },
        }
      );
    }
    
    
   
  }



  return (
    <>
      <div className={'rejectedPayments'}>
        <div className={'rejectedPaymentsBreadcrumb'}>
          <div>Payments</div>
          <svg
            width="10"
            height="13"
            viewBox="0 0 10 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 1.5744L0 11.4256C0 11.8254 0.236844 12.192 0.613658 12.3774C0.991157 12.5628 1.44706 12.5363 1.79669 12.3087L9.55942 7.25661C9.83645 7.07665 10.0007 6.78017 10 6.46438C9.99858 6.14825 9.83207 5.85271 9.55431 5.6742L1.79158 0.68791C1.44044 0.462617 0.986688 0.438175 0.610557 0.623958C0.235339 0.809997 0 1.1757 0 1.5744Z"
              fill="#6366F1"
            />
          </svg>
          <div>Reprocess Unpaid Payments</div>

          <svg
            width="10"
            height="13"
            viewBox="0 0 10 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 1.5744L0 11.4256C0 11.8254 0.236844 12.192 0.613658 12.3774C0.991157 12.5628 1.44706 12.5363 1.79669 12.3087L9.55942 7.25661C9.83645 7.07665 10.0007 6.78017 10 6.46438C9.99858 6.14825 9.83207 5.85271 9.55431 5.6742L1.79158 0.68791C1.44044 0.462617 0.986688 0.438175 0.610557 0.623958C0.235339 0.809997 0 1.1757 0 1.5744Z"
              fill="#6366F1"
            />
          </svg>

          <div>Rejected Payments</div>
        </div>

        <div className={'rejectedPaymentsSummary'}>
          <div className={'rpsRow1'}>
            <div>Payment Summary</div>

            <div>
              <div>₦{(Number(totalPayableSum )+ Number(processingFee)).toLocaleString()}</div>
              <div>Grand total payable</div>
            </div>

            <div>
              <div>
                <div className={'psTitle'}>Payment Type</div>
                <div className={'psValue'}>{paymentInstruction['0'].paymentType.description}</div>
              </div>

              <div>
                <div className={'psTitle'}>Batch Number</div>
                <div className={'psValue'}>{ data?.content?.data?.batchId }</div>
              </div>

              <div>
                <div className={'psTitle'}>Transaction Count</div>
                <div className={'psValue'}>{paymentInstruction.length}</div>
              </div>

              <div>
                <div className={'psTitle'}>Total Amount Payable</div>
              <div className={'psValue'}>₦ {totalPayableSum}</div>
              </div>

              <div>
                <div className={'psTitle'}>Processing Fee</div>
              <div className={'psValue'}>₦ {processingFee}</div>
              </div>
            </div>
          </div>

          <div className={'rpsRow2'}>
            <div>
          

            </div>

            <div className={'submitCancelButton'}>
              {/*{*/}
              {/*    accountToMakePaymentFrom === '' ?*/}
              {/*        <button disabled onClick={() => setConfirmationModal(true)}>Submit</button> :*/}
              {/*        <button onClick={() => setConfirmationModal(true)}>Submit</button>*/}
              {/*}*/}

              <div>
                {/* <button>Cancel</button> */}
              </div>

              <div>
                <button onClick={() => setConfirmationModal(true)}>
                  Reprocess
                </button>
              </div>
            </div>
          </div>

          <div className={'psRow3'} style={{ overflowX: "auto" }}>
            <Table
              rowSelection={rowSelection}
              dataSource={[...dataSourceD]}
              columns={columns}
              scroll={{ x: "1200px" }}
              bordered
            />
          </div>
        </div>

        <Modal
          centered
          style={{ width: '500px', maxWidth: '100%' }}
          open={confirmationModal}
          onOk={() => setConfirmationModal(false)}
          onCancel={() => setConfirmationModal(false)}
          footer={null}
        >
          <div className={'rvpConfirmationModal'}>
            <svg
              style={{ justifySelf: 'center' }}
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.2499 13.8755C11.2499 14.2897 11.5857 14.6255 11.9999 14.6255C12.4142 14.6255 12.7499 14.2897 12.7499 13.8755H11.2499ZM11.9999 12.938V12.188C11.801 12.188 11.6103 12.267 11.4696 12.4077C11.329 12.5483 11.2499 12.7391 11.2499 12.938H11.9999ZM7.96869 9.65678C7.96869 10.071 8.30448 10.4068 8.71869 10.4068C9.1329 10.4068 9.46869 10.071 9.46869 9.65678H7.96869ZM22.5 12C22.5 17.799 17.799 22.5 12 22.5V24C18.6274 24 24 18.6274 24 12H22.5ZM12 22.5C6.20101 22.5 1.5 17.799 1.5 12H0C0 18.6274 5.37258 24 12 24V22.5ZM1.5 12C1.5 6.20101 6.20101 1.5 12 1.5V0C5.37258 0 0 5.37258 0 12H1.5ZM12 1.5C17.799 1.5 22.5 6.20101 22.5 12H24C24 5.37258 18.6274 0 12 0V1.5ZM12.6562 18.0938C12.6562 18.4562 12.3624 18.75 12 18.75V20.25C13.1909 20.25 14.1562 19.2846 14.1562 18.0938H12.6562ZM12 18.75C11.6376 18.75 11.3438 18.4562 11.3438 18.0938H9.84375C9.84375 19.2846 10.8091 20.25 12 20.25V18.75ZM11.3438 18.0938C11.3438 17.7313 11.6376 17.4375 12 17.4375V15.9375C10.8091 15.9375 9.84375 16.9029 9.84375 18.0938H11.3438ZM12 17.4375C12.3624 17.4375 12.6562 17.7313 12.6562 18.0938H14.1562C14.1562 16.9029 13.1909 15.9375 12 15.9375V17.4375ZM12.7499 13.8755V12.938H11.2499V13.8755H12.7499ZM11.9999 13.688C12.7972 13.688 13.5766 13.4516 14.2396 13.0086L13.4062 11.7614C12.99 12.0396 12.5006 12.188 11.9999 12.188L11.9999 13.688ZM14.2396 13.0086C14.9025 12.5657 15.4192 11.9361 15.7243 11.1995L14.3385 10.6254C14.1469 11.088 13.8225 11.4833 13.4062 11.7614L14.2396 13.0086ZM15.7243 11.1995C16.0294 10.4629 16.1093 9.6523 15.9537 8.87032L14.4826 9.16295C14.5802 9.65397 14.5301 10.1629 14.3385 10.6254L15.7243 11.1995ZM15.9537 8.87032C15.7982 8.08833 15.4142 7.37003 14.8505 6.80625L13.7898 7.86691C14.1438 8.22091 14.3849 8.67194 14.4826 9.16295L15.9537 8.87032ZM14.8505 6.80625C14.2867 6.24247 13.5684 5.85853 12.7864 5.70299L12.4938 7.17416C12.9848 7.27183 13.4358 7.51291 13.7898 7.86691L14.8505 6.80625ZM12.7864 5.70299C12.0044 5.54744 11.1939 5.62727 10.4572 5.93239L11.0313 7.31821C11.4938 7.12662 12.0027 7.0765 12.4938 7.17416L12.7864 5.70299ZM10.4572 5.93239C9.72063 6.2375 9.09104 6.7542 8.64808 7.41713L9.89528 8.25049C10.1734 7.83423 10.5687 7.50979 11.0313 7.31821L10.4572 5.93239ZM8.64808 7.41713C8.20512 8.08007 7.96869 8.85947 7.96869 9.65678H9.46869C9.46869 9.15614 9.61715 8.66675 9.89528 8.25049L8.64808 7.41713Z"
                fill="#61CD85"
              />
            </svg>

            {/*<div className={'rdFilterModalRow1'}>*/}
            <div className={'rvpConfirmationModalTitle'}>Confirmation</div>
            {/*</div>*/}

            <div style={{ justifySelf: 'center' }}>
              Please confirm you want to proceed with this request
            </div>

            <div className={'rvpConfirmationModalActionButton'}>
              <button
                className="btn btn-outline-success px-7 py-2 h-44 w-200 rounded-1 "
                onClick={() => setConfirmationModal(false)}
              >
                <span className="indicator-label fs-base">Cancel</span>
              </button>

              <button
                onClick={() => {
                submit()
                }}
                className="btn btn-success px-7 py-2 h-44 w-150 rounded-1 "
              >
                <span className="indicator-label fs-base text-White">
                  Proceed
                </span>
              </button>
            </div>
          </div>
        </Modal>

        <Modal
          centered
          style={{ width: '500px', maxWidth: '100%' }}
          open={successModal}
          onOk={() => setSuccessModal(false)}
          onCancel={() => setSuccessModal(false)}
          footer={null}
        >
          <div className={'rvpConfirmationModal'}>
            <svg
              style={{ justifySelf: 'center' }}
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.1562 9.1875L10.2812 15.75L6.84375 12.4688M23.25 12C23.25 18.2132 18.2132 23.25 12 23.25C5.7868 23.25 0.75 18.2132 0.75 12C0.75 5.7868 5.7868 0.75 12 0.75C18.2132 0.75 23.25 5.7868 23.25 12Z"
                stroke="#61CD85"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            <div className={'rvpConfirmationModalTitle'}>Successful!</div>

            <div style={{ textAlign: 'center' }}>
            The transactions has been successfully sent for reprocessing
            </div>

            <div className={'rvpConfirmationModalActionButton'}>
              <button
                className="btn btn-success px-7 py-2 h-44 w-150 rounded-1 "
                onClick={() => {
                  setSuccessModal(false);
                  setDataSource([]);
                  navigate('/admin/payment/reprocess-unpaid-payments');
                }}
              >
                <span className="indicator-label fs-base text-White">Ok</span>
              </button>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default RejectedPayments;
